﻿export default {
    q: function(obj) {

        // Copyright: Thomas Frank 2010, v 1.021 (MIT style license, see EULA)

        // variables
        var a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z, obj2, d2, toSort, sortParas, ohaving, ot, coMax, co, labels,
            xLen, whereIndexes, distinct, distinctHash, ags, fieldCo, distinctKey, pname, theVal, ag_type,
            agsCo, uu, orgD, o2, o3, intoAr, owhere, ewhere, setop, f1, f2, f1name, f2name, func, fh, tc, f2, lex, setopFuncHolder, joinFuncHolder;

        // The strange "funcHolder" vars fixes eluding AS2-bug where a function defined in a if clause is not readily available...
        // (could have been rewritten with var x = function, but this wouldn't have worked in AS3)

        // handle multiple commands/inparameters
        if (arguments.length > 1) {
            a = arguments;
            r = uu;
            for (i = 0; i < a.length; i++) {
                r = this.q(a[i]);
            }
            return r;
        }

        // o - new object with all the props in uppercase, without underscore
        o = {};
        Object.keys(obj).forEach(prop => {
            o[prop.toUpperCase().split("_").join("")] = obj[prop];
        });

        // check that we have ONE basic query type
        if (o.DELETE && o.FROM) {
            o.DELETEFROM = o.FROM;
        }
        setop = !!o.UNIONDISTINCT + !!o.UNION + !!o.UNIONALL + !!o.INTERSECTDISTINCT + !!o.INTERSECT +
            !!o.INTERSECTALL + !!o.MINUS + !!o.EXCEPTDISTINCT + !!o.EXCEPT + !!o.EXCEPTALL;
        if (setop + !!o.SELECT + !!o.SELECTDISTINCT + !!o.INSERTINTO + !!o.UPDATE + !!o.DELETEFROM + !!o.UNPACK + !!o.PACK != 1) {
            return [];
        } else if (o.TESTSUB) {
            return "issub";
        }

        // d - our data provider (an array of objects)
        d = (o.SELECT || o.SELECTDISTINCT) ? o.FROM : o.INSERTINTO || o.UPDATE || o.DELETEFROM || o.PACK || o.UNPACK, orgD = d;

        // test if d is a subquery and if so perform it
        if (d && typeof d == "object" && !d.push) {
            o2 = {
                TESTSUB: true
            };
            Object.keys(d).forEach(prop => {
                o2[prop] = d[prop];
            });
            if (this.q(o2) == "issub") {
                d = this.q(d);
            }
        }

        // LIMIT
        if (o.LIMIT) {
            x = o.LIMIT;
            o.LIMIT = uu;
            return this.q(o).slice(0, x);
        }

        // INTO
        if (o.INTO && o.INTO.push) {
            intoAr = o.INTO;
            o.INTO = uu;
            intoAr.splice.apply(intoAr, [intoAr.length, 0].concat(this.q(o)));
            return intoAr;
        }

        // INSERT INTO
        if (o.INSERTINTO) {
            d.push(o.VALUES);
            return d;
        }

        // UNION, INTERSECT, EXCEPT, MINUS (set operations)
        if (setop) {
            setopFuncHolder = {
                f: function(o, a) {
                    var x = [],
                        All, Type, dr = [],
                        f = {},
                        f2 = {},
                        h = {},
                        k, hkey, hash = {},
                        testHash, mfd = [],
                        d = o.UNIONDISTINCT || o.UNION || o.UNIONALL || o.INTERSECTDISTINCT || o.INTERSECT ||
                        o.INTERSECTALL || o.MINUS || o.EXCEPTDISTINCT || o.EXCEPT || o.EXCEPTALL,
                        lex = d.length;
                    // determine query type 
                    for (var z in o) {
                        if (o[z] === d) {
                            var j = z.toUpperCase();
                            All = j.split("ALL").length > 1;
                            Type = j.split("UNION").length > 1 ? 1 : j.split("INTERSECT").length > 1 ? 2 : 3;
                            if (j == "MINUS") {
                                Type = 3;
                                All = false;
                            }
                        }
                    }
                    // perform subqueries
                    for (var i = 0; i < d.length; i++) {
                        dr.push(a(d[i]));
                    }
                    // determine shared fieldnames
                    for (i = 0; i < lex; i++) {
                        if (dr[i].length) {
                            Object.keys(dr[i][0]).forEach(prop => {
                                if (!f[prop]) {
                                    f[prop] = 0;
                                }
                                f[prop]++;
                            });
                        }
                    }
                    for (i in f) {
                        // if (f[i] == lex) {
                            f2[i] = true;
                        // }
                    }
                    // concatenate tables and build hash info
                    for (i = 0; i < lex; i++) {
                        for (let j = 0; j < dr[i].length; j++) {
                            o = {};
                            hkey = [];
                            Object.keys(f2).forEach(prop => {
                                o[prop] = dr[i][j][prop];
                                hkey.push(dr[i][j][prop]);
                            });
                            hkey = hkey.join("|||");
                            x.push(o);
                            if (!hash[hkey]) {
                                hash[hkey] = [];
                            }
                            hash[hkey].push({
                                indexNo: x.length - 1,
                                // fabio tableNo: 't' + i
                                tableNo: 'f' + i
                            });
                        }
                    }
                    // just return if UNIONALL
                    if (Type == 1 && All) {
                        return x;
                    }
                    // mark tuples for deletion depending on query type
                    Object.keys(hash).forEach(prop => {
                        testHash = {};
                        for (let j = 0; j < hash[prop].length; j++) {
                            testHash[hash[prop][j].tableNo] = true;
                        }
                        let testHashCo = Object.keys(testHash).length;
                        for (let j = 0; j < hash[prop].length; j++) {
                            if (
                                (Type == 2 && testHashCo != lex) ||
                                (Type == 3 && (testHashCo != 1 || testHash.f1)) ||
                                (!All && j > 0)
                            ) {
                                mfd[hash[prop][j].indexNo] = true;
                            }
                        }
                    });
                    // delete tuples
                    for (i = x.length - 1; i >= 0; i--) {
                        if (mfd[i]) {
                            x.splice(i, 1);
                        }
                    }
                    return x;
                }
            };
            return setopFuncHolder.f(o, this.q);
        }

        // UNPACK - from array of arrays to array of objects
        if (o.UNPACK) {
            c = o.COLUMNS;
            if (!c) {
                return false;
            }
            for (i = 0; i < d.length; i++) {
                o = {};
                for (let j = 0; j < c.length; j++) {
                    o[c[j]] = d[i][j];
                }
                d[i] = o;
            }
            return d;
        }

        // PACK - from array of objects to array of arrays
        if (o.PACK) {
            if (!o.COLUMNS) {
                o.COLUMNS = [];
                Object.keys(d[0]).forEach(prop => {
                    o.COLUMNS.push(prop);
                });
            }
            c = o.COLUMNS;
            for (i = 0; i < d.length; i++) {
                a = [];
                for (let j = 0; j < c.length; j++) {
                    a[j] = d[i][c[j]];
                }
                d[i] = a;
            }
            return d;
        }

        // ORDER BY
        if (o.ORDERBY && !o.ORDERBY.prep) {
            o.ORDERBY.prep = true;
            x = this.q(o);
            toSort = [];
            if (o.GROUPBY) {
                x = [x, x];
            }
            // build toSort from selected x[0] and unselected x[1] fields
            for (i = 0; i < x[0].length; i++) {
                a = {};
                co = 0;
                Object.keys(x[0][i]).forEach(prop => {
                    co++;
                    a[prop] = x[0][i][prop];
                });
                Object.keys(x[1][i]).forEach(prop => {
                    co++;
                    if (a[prop] === uu) {
                        a[prop] = x[1][i][prop];
                    }
                });
                a.__sqLikeSelectedData = x[0][i];
                toSort.push(a);
            }
            // check asc/desc
            sortParas = {
                a: [],
                d: []
            };
            a = o.ORDERBY || [];
            f = undefined;
            x = sortParas;
            for (i = 0; i < a.length; i++) {
                if (a[i] == "|desc|" || a[i] == "|asc|") {
                    continue;
                }
                x.d.push(a[i + 1] == "|desc|" ? -1 : 1);
                x.a.push(a[i]);
            }
            // sort
            toSort.sort(function(x, y) {
                a = sortParas.a;
                d = sortParas.d;
                r = 0;
                for (i = 0; i < a.length; i++) {
                    if (typeof x + typeof y != "objectobject") {
                        return typeof x == "object" ? -1 : 1;
                    }
                    let m, n;
                    if (typeof a[i] == "function") {
                        m = a[i].apply(x);
                        n = a[i].apply(y);
                    } else {
                        m = x[a[i]];
                        n = y[a[i]];
                    }
                    if ((m === true || m === false) && (n === true || n === false)) {
                        m *= -1;
                        n *= -1;
                    }
                    r = m - n;
                    if (isNaN(r)) {
                        r = m > n ? 1 : m < n ? -1 : 0;
                    }
                    if (r != 0) {
                        return r * d[i];
                    }
                }
                return r;
            });
            // retrieve selected fields
            r = [];
            for (i = 0; i < toSort.length; i++) {
                r.push(toSort[i].__sqLikeSelectedData);
            }
            return r;
        }

        // HAVING
        if (o.HAVING) {
            ohaving = o.HAVING;
            o.HAVING = uu;
            x = this.q(o);
            r = this.q({
                SELECT: ['*'],
                FROM: x,
                WHERE: ohaving
            });
            return r;
        }

        // GROUP BY    
        if (o.GROUPBY) {
            const modoNovo = true
            if (modoNovo) {
                ags = {};
                g = o.GROUPBY;
                s = o.SELECT || o.SELECTDISTINCT;
                const nomesOriginais = {}
                for (j = 0; j < s.length; j++) {
                    pname = s[j];
                    if (typeof s[j] == "string" && s[j].toLowerCase() == "|as|") {
                        j += 1;
                        continue;
                    }
                    if (typeof s[j] == "string" && s[j].charAt(0) == "|" && s[j].charAt(s[j].length - 1) == "|") {
                        continue;
                    }
                    if (typeof s[j + 1] == "string" && typeof s[j + 2] == "string" && s[j + 1].toLowerCase() == "|as|") {
                        pname = s[j + 2];
                        nomesOriginais[pname] = s[j]
                    }
                    if (typeof s[j - 1] == "string" && s[j - 1].charAt(0) == "|" && s[j - 1].charAt(s[j - 1].length - 1) == "|") {
                        ag_type = s[j - 1].split('|')[1];
                        //fabio pname = ag_type + '_' + pname;
                        ags[pname] = ag_type;
                    }
                }
                
                const campos = [].concat(g).concat(Object.keys(ags)), 
                    argKeys = Object.keys(ags),
                    temMedia = argKeys.find(ak => ags[ak] == 'avg'),
                    temContador = argKeys.find(ak => ags[ak] == 'count')
                var helper = {};
                var resultado = o.FROM.reduce(function(r, o) {
                    var key = g.map(g => o[g]).join('|')

                    if(!helper[key]) {
                        helper[key] = Object.assign({}, o);
                        // remove os campos que não são usados
                        Object.keys(helper[key]).forEach(prop => {
                            if (!campos.includes(prop)) {
                                let novoNome = campos.find(c => nomesOriginais[c] == prop)
                                if(novoNome && novoNome !== prop) // Confere se é um campo com Novo Nome. Troca e deleta o antigo
                                    helper[key][novoNome] = helper[key][prop]
                                
                                delete helper[key][prop]
                            }
                        });
                        // inicializa os campos com função contador
                        argKeys.filter(prop => ags[prop] == 'count').forEach(prop => {
                            helper[key][prop+'_array'] = []
                            helper[key][prop] = o[prop] != undefined ? 1 : 0
                        });
                        // se tem média adiciona um contador pra fazer o cálculo no final
                        if (temMedia) {
                            helper[key]._cont = 1
                        }
                        r.push(helper[key])
                    } else {
                        // se tem média incrementa o contador pra fazer o cálculo no final
                        if (temMedia) {
                            helper[key]._cont++
                        }
                        argKeys.forEach(prop => {
                            switch (ags[prop]) {
                                case 'sum':
                                case 'avg':
                                    if(helper[key][prop] === undefined)
                                        helper[key][prop] = 0
                                    if(o[prop] === undefined)
                                        o[prop] = 0
                                    helper[key][prop] += o[prop]
                                    break;
                                case 'max':
                                    if (o[prop] > helper[key][prop]) {
                                        helper[key][prop] = o[prop]
                                    }
                                    break;
                                case 'min':
                                    if (o[prop] < helper[key][prop]) {
                                        helper[key][prop] = o[prop]
                                    }
                                    break;
                                case 'count':
                                    //helper[key][prop]++
                                    if (o[prop] != undefined && helper[key][prop+'_array'].indexOf(o[prop]) < 0) {
                                        helper[key][prop+'_array'].push(o[prop])
                                        helper[key][prop]++
                                    }
                                    break;
                            }
                        });
                    }
                    return r;
                }, []);

                if (temMedia) {
                    // se tem média em algum campo, calcula e remove o contador auxiliar de todos os registros
                    const propsMedia = argKeys.filter(prop => ags[prop] == 'avg')
                    resultado.forEach(r => {
                        propsMedia.forEach(prop => {
                            r[prop] = r[prop] / r._cont
                        });
                        delete r._cont
                    })
                }

                if (temContador) {
                    // se tem contador em algum campo, calcula
                    const propsCount = argKeys.filter(prop => ags[prop] == 'count')
                    resultado.forEach(r => {
                        propsCount.forEach(prop => {
                            delete r[prop+'_array']
                        });
                    })                    
                    
                }
        
                return resultado
            }
            //  else {
        
            // //jeito antigo - início
            // // bonito mas nada performático
            // t = [];
            // q = {
            //     SELECTDISTINCT: o.GROUPBY,
            //     FROM: o.FROM,
            //     WHERE: o.WHERE
            // };
            // g = this.q(q);
            // for (i = 0; i < g.length; i++) {
            //     q = {};
            //     Object.keys(o).forEach(prop => {
            //         q[prop] = o[prop];
            //     });
            //     q.GROUPBY = q.ORDERBY = uu;
            //     owhere = o.WHERE || function() {
            //         return true;
            //     };
            //     ewhere = g[i];
            //     q.WHERE = function() {
            //         var x = owhere.apply(this);
            //         Object.keys(ewhere).forEach(prop => {
            //             // x = x && this[prop] == ewhere[prop]; Fabio #77895 -> comparação com data não funcionava por ser objeto
            //             if (typeof this[prop] === 'object') {
            //                 x = x && JSON.stringify(this[prop]) == JSON.stringify(ewhere[prop]);
            //             } else {
            //                 x = x && this[prop] == ewhere[prop];
            //             }
            //         });
            //         return x;
            //     };
            //     t.push(this.q(q)[0]);
            // }
            // return t;
            // //jeito antigo - fim
            // }
        }

        // JOIN - convert all types of joins to where clauses + outer flags
        o.JOIN = o.JOIN || o.INNERJOIN || o.NATURALJOIN || o.CROSSJOIN || o.LEFTOUTERJOIN || o.RIGHTOUTERJOIN ||
            o.LEFTJOIN || o.RIGHTJOIN || o.FULLOUTERJOIN || o.OUTERJOIN || o.FULLJOIN;
        if (o.NATURALJOIN || o.USING) {

            // optimize by building a hash for equijoin thereby omitting loops in the on clause for 2-3 table joins
            // ugly code block but saves som milliseconds, before this "naturaljoin" and "join using"
            // were really slow, now they're almost on par with other types of joins

            Object.keys(o.JOIN).forEach(prop => {
                if (!d[prop]) {
                    d[prop] = o.JOIN[prop];
                }
            });
            f = {};
            f2 = [];
            lex = 0;
            Object.keys(d).forEach(prop => {
                lex++;
                Object.keys(d[prop][0]).forEach(prop2 => {
                    if (!f[prop2]) {
                        f[prop2] = 0;
                    }
                    f[prop2]++;
                });
            });
            for (i in f) {
                if (f[i] == lex) {
                    f2.push(i);
                }
            }
            o.USING = o.USING || f2;
            b = {};
            for (i = 0; i < o.USING.length; i++) {
                b[o.USING[i]] = true;
            }
            Object.keys(d).forEach(prop => {
                x = d[prop];
                d[prop] = [];
                for (k = 0; k < x.length; k++) {
                    o2 = {};
                    h = [];
                    Object.keys(x[k]).forEach(prop2 => {
                        o2[prop2] = x[k][prop2];
                    });
                    for (j = 0; j < o.USING.length; j++) {
                        h.push(x[k][o.USING[j]]);
                    }
                    o2.__SQLikeHash__ = h.join('|');
                    d[prop][k] = o2;
                }
            });
            o.ON = function() {
                var a = this.q;
                if (a.LEN == 2) {
                    return this[a.TABLELABEL[0]].__SQLikeHash__ ==
                        this[a.TABLELABEL[1]].__SQLikeHash__ ? a.USINGOBJ : false;
                }
                if (a.LEN == 3) {
                    return this[a.TABLELABEL[0]].__SQLikeHash__ ==
                        this[a.TABLELABEL[1]].__SQLikeHash__ &&
                        this[a.TABLELABEL[0]].__SQLikeHash__ ==
                        this[a.TABLELABEL[2]].__SQLikeHash__ ? a.USINGOBJ : false;
                }
                var x = this[a.TABLELABEL[0]].__SQLikeHash__;
                for (var i in this) {
                    if (this[i].__SQLikeHash__ != x) {
                        return false;
                    }
                }
                return a.USINGOBJ;
            };
            o.ON.TABLELABEL = [];
            Object.keys(d).forEach(prop => {
                o.ON.TABLELABEL.push(prop);
            });
            o.ON.USINGOBJ = b;
            o.ON.LEN = lex;
            o.NATURALJOIN = o.USING = uu;
        }
        if (o.CROSSJOIN) {
            o.ON = function() {
                return true;
            };
            o.CROSSJOIN = false;
        }
        if (o.JOIN && o.ON && !d.join && !o.JOIN.join) {
            Object.keys(o.JOIN).forEach(prop => {
                if (!d[prop]) {
                    d[prop] = o.JOIN[prop];
                }
            });
            ot = {}, k;
            Object.keys(d).forEach(prop => {
                if (o.FULLOUTERJOIN || o.FULLJOIN || o.OUTERJOIN) {
                    k = true;
                    ot[prop] = true;
                }
                if ((o.LEFTOUTERJOIN || o.LEFTJOIN) && !o.JOIN[prop]) {
                    k = true;
                    ot[prop] = true;
                }
                if ((o.RIGHTOUTERJOIN || o.RIGHTJOIN) && o.JOIN[prop]) {
                    k = true;
                    ot[prop] = true;
                }
            });
            o.OUTERTABLES = k ? ot : false;
            f = o.WHERE || function() {
                return true;
            };
            o.WHERE = o.ON;
            o.WHERE.org = f;
            o.JOIN = o.INNERJOIN = o.NATURALJOIN = o.CROSSJOIN = o.LEFTOUTERJOIN = o.RIGHTOUTERJOIN = o.LEFTJOIN =
                o.RIGHTJOIN = o.FULLOUTERJOIN = o.OUTERJOIN = o.FULLJOIN = o.ON = uu;
            return this.q(o);
        }

        // JOIN (from WHERE clause)
        if (!d.join) {
            joinFuncHolder = {
                f: function(x, where, outer) {
                    var d = [],
                        e = [],
                        coMax = [],
                        co = [],
                        labels = [],
                        xLen = 0,
                        m = [];
                    Object.keys(x).forEach(prop => {
                        coMax.push(x[prop].length);
                        labels.push(prop);
                        m.push([]);
                        co.push(0);
                        xLen++;
                    });
                    while (co[xLen - 1] < coMax[xLen - 1]) {
                        var o = {};
                        for (i = 0; i < xLen; i++) {
                            o[labels[i]] = x[labels[i]][co[i]];
                        }
                        q = where.apply(o);
                        if (q) {
                            if (outer) {
                                for (i = 0; i < xLen; i++) {
                                    m[i][co[i]] = true;
                                }
                            }
                            obj = {};
                            for (i = 0; i < xLen; i++) {
                                Object.keys(o[labels[i]]).forEach(prop => {
                                    if (prop !== "__SQLikeHash__") {
                                        obj[(typeof q == "object" && q[prop] ? '' : labels[i] + '_') + prop] = o[labels[i]][prop];
                                    }
                                });
                            }
                            d.push(obj);
                            e.push(o);
                        }
                        for (i = 0; i < xLen; i++) {
                            co[i]++;
                            if (co[i] < coMax[i]) {
                                break;
                            }
                            if (i < xLen - 1) {
                                co[i] = 0;
                            }
                        }
                    }
                    if (outer) {
                        for (i = 0; i < xLen; i++) {
                            if (!outer[labels[i]]) {
                                continue;
                            }
                            for (j = 0; j < coMax[i]; j++) {
                                if (!m[i][j]) {
                                    let o1 = x[labels[i]][j];
                                    o2 = {};
                                    o3 = {};
                                    for (k = 0; k < xLen; k++) {
                                        o3[labels[k]] = {};
                                    }
                                    Object.keys(o1).forEach(prop => {
                                        o3[labels[i]][prop] = o1[prop];
                                        o2[labels[i] + "_" + prop] = o1[prop];
                                    });
                                    d.push(o2);
                                    e.push(o3);
                                }
                            }
                        }
                    }
                    if (where.org) {
                        for (i = d.length - 1; i >= 0; i--) {
                            if (!where.org.apply(e[i])) {
                                d.splice(i, 1);
                            }
                        }
                    }
                    return d;
                }
            };
            d = joinFuncHolder.f(d, o.WHERE, o.OUTERTABLES);
        }

        // WHERE
        else {
            d2 = [];
            whereIndexes = [];
            for (i = 0; i < d.length; i++) {
                if (!o.WHERE || o.WHERE.apply(d[i])) {
                    d2.push(d[i]);
                    whereIndexes.push(i);
                }
            }
            d = d2;
        }

        // DELETE
        if (o.DELETEFROM) {
            for (i = whereIndexes.length - 1; i >= 0; i--) {
                orgD.splice(whereIndexes[i], 1);
            }
            return orgD;
        }

        // UPDATE
        if (o.UPDATE && o.SET) {
            for (i = 0; i <= whereIndexes.length; i++) {
                o.SET.apply(orgD[whereIndexes[i]]);
            }
            return orgD;
        }

        // SELECT
        distinct = !!o.SELECTDISTINCT;
        o.SELECT = o.SELECT || o.SELECTDISTINCT;
        if (o.SELECT && o.SELECT.length > 0) {
            d2 = [];
            distinctHash = {};
            ags = {};
            fieldCo = 0;
            s = o.SELECT;
            if (s[0] == "|count|" && s[1] == "*") {
                return [{
                    count: d.length
                }];
            }
            for (i = 0; i < s.length; i++) {
                if (s[i] == "*") {
                    h = {};
                    t = [];
                    for (k = 0; k < d.length; k++) {
                        Object.keys(d[k]).forEach(prop => {
                            if (!h[prop]) {
                                t.push(prop);
                                h[prop] = true;
                            }
                        });
                    }
                    s.splice(i, 1);
                    for (j = t.length - 1; j >= 0; j--) {
                        s.splice(i, 0, t[j]);
                    }
                    break;
                }
            }
            for (i = 0; i < d.length; i++) {
                obj = {};
                distinctKey = undefined;
                for (j = 0; j < s.length; j++) {
                    pname = s[j];
                    theVal = d[i][pname];
                    if (typeof s[j] == "string" && s[j].toLowerCase() == "|as|") {
                        j += 1;
                        continue;
                    }
                    if (typeof s[j] == "string" && s[j].charAt(0) == "|" && s[j].charAt(s[j].length - 1) == "|") {
                        continue;
                    }
                    if (typeof pname == "function") {
                        theVal = pname.apply(d[i]);
                        co = 1;
                        pname = "udf_1";
                        while (obj[pname]) {
                            co++;
                            pname = "udf_" + co;
                        }
                    }
                    if (typeof s[j + 1] == "string" && typeof s[j + 2] == "string" && s[j + 1].toLowerCase() == "|as|") {
                        pname = s[j + 2];
                    }
                    if (typeof s[j - 1] == "string" && s[j - 1].charAt(0) == "|" && s[j - 1].charAt(s[j - 1].length - 1) == "|") {
                        ag_type = s[j - 1].split('|')[1];
                        //fabio pname = ag_type + '_' + pname;
                        ags[pname] = {
                            type: ag_type,
                            count_array: [],
                            count: 0,
                            sum: 0,
                            avg: 0
                        };
                    }
                    if (o.JHELP && !o.JHELP[pname]) {
                        pname = o.JTNAME + pname;
                    }
                    obj[pname] = theVal;
                    if (i == 0) {
                        fieldCo++;
                    }
                }

                if (distinct) {
                    x = [];
                    Object.keys(obj).forEach(prop => {
                        x.push(obj[prop]);
                    });
                    distinctKey = x.join('|||');
                }
                if (!distinct || !distinctHash[distinctKey]) {
                    d2.push(obj);
                }
                if (distinct) {
                    distinctHash[distinctKey] = true;
                }
            }
            // aggregate functions
            agsCo = 0;
            Object.keys(ags).forEach(prop => {
                agsCo++;
                y = ags[prop];
                for (j = 0; j < d2.length; j++) {
                    x = d2[j][prop];
                    if (x !== uu) {
                        if (x != undefined && y.count_array.indexOf(x) < 0) {
                            y.count_array.push(x)
                            y.count++;
                        }
                        if (y.min === uu) {
                            y.min = x;
                        }
                        if (y.max === uu) {
                            y.max = x;
                        }
                        if (y.min > x) {
                            y.min = x;
                        }
                        if (y.max < x) {
                            y.max = x;
                        }
                        if (x / 1 == x) {
                            y.sum += x;
                        }
                    }
                }
                y.avg = y.sum / y.count;
                d2[0][prop] = ags[prop][ags[prop].type];
            });
            if (agsCo > 0) {
                d2 = [d2[0]];
                d = [d2[0]];
            }
            if (o.ORDERBY && o.ORDERBY.prep) {
                return [d2, d];
            }
            return d2;
        }

        return [];
    }
};